import React, { PureComponent } from 'react';
import { Table, Button, Pagination, Select } from 'element-react';
import style from './index.scss';
import styles from './search.css'

import { Link } from 'react-router-dom';


export default class Search extends PureComponent {

    state = {
        army: [{
            value: '伤残',
            label: '伤残'
        }, {
            value: '三红',
            label: '三红'
        }, {
            value: '三属',
            label: '三属'
        }, {
            value: '在乡老复原军人',
            label: '在乡老复原军人'
        }, {
            value: '带病回乡退伍军人',
            label: '带病回乡退伍军人'
        }, {
            value: '参战退伍军人',
            label: '参战退伍军人'
        }],
        army2: [{
            value: '三亚市',
            label: '三亚市'
        }, {
            value: '海口市',
            label: '海口市'
        }, {
            value: '三沙市',
            label: '三沙市'
        }, {
            value: '儋州市',
            label: '儋州市'
        }, {
            value: '五指山市',
            label: '五指山市'
        }, {
            value: '文昌市',
            label: '文昌市'
        }, {
            value: '琼海市',
            label: '琼海市'
        }, {
            value: '万宁市',
            label: '万宁市'
        }, {
            value: '东方市',
            label: '东方市'
        }],

        army3: [{
            value: '海棠区',
            label: '海棠区'
        }, {
            value: '吉阳区',
            label: '吉阳区'
        }, {
            value: '天涯区',
            label: '天涯区'
        }, {
            value: '崖州区',
            label: '崖州区'
        }, {
            value: '退役军人',
            label: '退役军人'
        }],
        army4: [{
            value: '全部',
            label: '全部'
        }, {
            value: '待审批',
            label: '待审批'
        }, {
            value: '已办结',
            label: '已办结'
        }, {
            value: '已退回',
            label: '已退回'
        }],
        value: '',
        areaValue: '',
        val: '',
        val2: '',
        val3: '',
        val4: '',
    };

    onRowClick = () => {
        window.location = '/preferentialDetail';
    }

    render() {
        const {
            city, army, army2, army3, army4, val, val2, val3, val4, value, areaValue
        } = this.state;

        const columns = [
            {
                label: "事项名称",
                prop: "name",
                width: 300,
                render: (row, column) => {
                    return <Link to='/preferential/preferentialDetail'> <span style={{ color: '#18388c' }}>{row.name}</span></Link>
                }
            },
            {
                label: "主管部门",
                prop: "department",
            },
            {
                label: "行政区划",
                prop: "administrator",
            },
            {
                label: "状态",
                prop: "state",
                render: (row, column) => {
                    return <span>{row.state}</span>
                }
            },
            {
                label: "操作",
                render: () => {
                    return <span style={{ color: '#18388c' }}><Button type="text" size="small">办事指南</Button></span>
                }
            }
        ];
        const dataSource = [
            { 'name': '海棠区办事处优抚补贴申请', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '海棠区办事处优抚补贴申请', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '海棠区办事处优抚补贴申请', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '海棠区办事处优抚补贴申请', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '海棠区办事处优抚补贴申请', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '海棠区办事处优抚补贴申请', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '海棠区办事处优抚补贴申请', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '海棠区办事处优抚补贴申请', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '海棠区办事处优抚补贴申请', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '海棠区办事处优抚补贴申请', 'department': '海棠区退役军人办事处', 'administrator': '三亚市海棠区', 'state': '待审批' },
        ];
        return (
            <div className="main_search">
                <div className="center" style={{ marginTop: '0' }}>
                    <div className="center_search">
                        <span style={{ color: '#18388c', fontSize: '24px', marginRight: '15px' }}>优抚查询</span><span style={{ lineHeight: '24px', marginRight: '10px' }}>申请类型</span>
                    </div>
                    <div style={{ marginTop: '30px' }}>
                        <span style={{ lineHeight: '24px', marginRight: '10px' }}>申请类型</span>
                        <Select style={{ marginRight: '10px' }}>
                            {
                                army.map(el => {
                                    return <Select.Option key={
                                        el.value
                                    }
                                        label={
                                            el.label
                                        }
                                        value={
                                            el.value
                                        }
                                    />
                                })
                            }
                        </Select>
                        <span style={{ lineHeight: '24px', marginRight: '10px' }}>行政区分</span>
                        <Select style={{ marginRight: '10px' }}>
                            {
                                army2.map(el => {
                                    return <Select.Option key={
                                        el.value
                                    }
                                        label={
                                            el.label
                                        }
                                        value={
                                            el.value
                                        }
                                    />
                                })
                            }
                        </Select>
                        <Select style={{ marginRight: '10px' }}>
                            {
                                army3.map(el => {
                                    return <Select.Option key={
                                        el.value
                                    }
                                        label={
                                            el.label
                                        }
                                        value={
                                            el.value
                                        }
                                    />
                                })
                            }
                        </Select>
                        <span style={{ lineHeight: '24px', marginRight: '10px' }}>状态</span>
                        <Select>
                            {
                                army4.map(el => {
                                    return <Select.Option key={
                                        el.value
                                    }
                                        label={
                                            el.label
                                        }
                                        value={
                                            el.value
                                        }
                                    />
                                })
                            }
                        </Select>
                    </div>
                    <div style={{ marginTop: '20px' }}>
                        <Table
                            style={{ width: '100%' }}
                            columns={columns}
                            data={dataSource}
                            border={true}
                        // onRowClick={this.onRowClick}
                        />
                    </div>

                    <div className="main_application">
                        <Pagination layout="prev, pager, next, jumper" total={1000} pageSize={100} currentPage={5} />
                    </div>

                </div>

            </div>
        )
    }
}